import { useContext } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { PageData } from '@swf/core/types/Poker';
import { PKR_INITIAL_STATE, PokerContext } from '@swf/poker';

const useGetWidgetState = () => {
  const {
    state: { widgetId }
  } = useContext(PokerContext);
  const state: PageData = useSelector((rootState: RootState) =>
    select.widgets.getData(rootState, widgetId)
  );

  return state || PKR_INITIAL_STATE;
};

export default useGetWidgetState;
